{"kind":{"alert":"Alert","task":"Task","inventory":"Inventory"},"nothingDue":"Nothing due on this day.","untitled":"Untitled","itemLabel":"{{kind}}: {{title}}"}